import { CoIntervuelogo } from "@assets/Icons";
import {
  LaptopRequiredCard,
  type LaptopRequiredCardProps,
} from "./LaptopRequiredCard";

export function LaptopRequiredScreen(props: LaptopRequiredCardProps) {
  return (
    <div className="auth-page h-dvh w-full flex items-center flex-col px-3 sm:px-0 overflow-y-auto py-6">
      <div className="my-auto flex flex-col items-center w-full max-w-md">
        <img
          src={CoIntervuelogo}
          alt="CoIntervue Logo"
          className="w-36 pb-3"
        />
        <LaptopRequiredCard {...props} />
      </div>
    </div>
  );
}
